import {
  //SYNC_SCORES
} from '../actions/types';

export default function(state = [], action){
  switch(action.type){
    // case SYNC_SCORES:
    //   return action.payload;
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/scoresReducer.js